module.exports = __webpack_public_path__ + "img/12.7d3934ba.png";